"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _school = require("@/api/school/school");
var _index = require("@/api/education/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      formInline: {
        schoolName: "",
        schoolCode: ""
      },
      rules: {
        schoolName: [{
          required: true,
          message: "请输入教育局名称",
          trigger: "blur"
        }, {
          min: 2,
          max: 30,
          message: "长度在 2 到 30 个字符",
          trigger: "blur"
        }],
        schoolCode: [{
          required: true,
          message: "请输入教育局编码",
          trigger: "blur"
        }]
      }
    };
  },
  methods: {
    onSubmit: function onSubmit(rulesForm) {
      var _this = this;
      this.$refs[rulesForm].validate(function (valid) {
        if (valid) {
          (0, _index.educationAdd)({
            id: "",
            isLock: 0,
            cityId: "",
            name: _this.formInline.schoolName,
            uniqueCode: _this.formInline.schoolCode
          }).then(function (res) {
            if (res.code === 2000) {
              _this.$message.success("操作成功");
              _this.$router.push("/schoolTest/educationList");
            }
          }).catch(function (e) {
            console.log(e);
          });
        } else {
          _this.$message.error("保存失败,请检查填写信息。");
          return false;
        }
      });
    },
    isBack: function isBack() {
      history.go(-1);
    }
  }
};